import React from "react";
import "./CardPromotion.css";

const promotions = [
  {
    id: 1,
    image: "/assets/bcimages/promotion/promotion-img-1.png",
    title: "Deposit Bonus In casino",
    endTime: "",
    extraImage: null,
  },
  {
    id: 2,
    image: "/assets/bcimages/promotion/promotion-img-2.png",
    title: "Deposit Bonus In casino",
    endTime: "",
    extraImage: null,
  },
 
];

const CardArchivePromotion = () => {
  return (
    <div className="main-card-promot">
      {promotions.map((promotion) => (
        <div key={promotion.id} className="CardPromotion-main-in">
          <div className="bc-promotion-main">
            <img
              style={{ borderRadius: "10px" }}
              className="bcpromotionimg"
              src={promotion.image}
              alt={promotion.title}
            />
            {promotion.extraImage && (
              <img
                className="rank-img"
                src={promotion.extraImage}
                alt="Extra Icon"
              />
            )}
          </div>
          <div className="casino-button-in">
            <div style={{ paddingTop: "10px" }}>
              <div className="deposite-heading">{promotion.title}</div>
              {promotion.endTime && (
                <div className="casino-button-in-time">{promotion.endTime}</div>
              )}
            </div>
            <h4 className="casino-progress">In Progress</h4>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardArchivePromotion;
